<template>
  <el-menu-item :index="menu.path" :key="menu.name" @click="routerToHandle(menu.path)">
    <template v-if="subItem" :to="{ name: menu.name }">{{ menu.meta.title }}</template>
    <template v-else >
      <i v-if="menu.meta.icon" :class="menu.meta.icon"/><span slot="title">{{ menu.meta.title }}</span>
    </template>
  </el-menu-item>
</template>

<script>
export default {
  name: 'menuItem',
  props: {
    menu: {
      type: Object,
      default: _ => {}
    },
    subItem: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    routerToHandle (path) {
      if(path){
        this.$router.push({path: path}).catch(error=>{
        })
      } else {
        this.$router.push({path: '/404'})
      }

    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/MainLayout/components/Menus/menuItem.vue